import React from 'react'
import { Message } from '@paypalcorp/worldready-react'

const NoOfferDetails = ({ offerType }: { offerType: string }): JSX.Element => {
  return (
    <li className="offer-details">
      <div
        data-cy="offer_details__no_offer"
        className="offer-details__no-offer"
      >
        <div>
          <Message id={`main.storePage.offerDetails.${offerType}`} />
        </div>
        <div className="offer-details__no-offer-subtitle">
          <Message id="main.storePage.offerDetails.noOffersDetails" />
        </div>
      </div>
    </li>
  )
}

export default NoOfferDetails
